module.exports = require('./dist/react-data-grid');



//////////////////
// WEBPACK FOOTER
// ./external/react-data-grid-4.0.8/packages/react-data-grid/index.js
// module id = 1059
// module chunks = 0